import { render, staticRenderFns } from "./CustomSubjectLine.vue?vue&type=template&id=5d6c700a&scoped=true&"
import script from "./CustomSubjectLine.vue?vue&type=script&lang=js&"
export * from "./CustomSubjectLine.vue?vue&type=script&lang=js&"
import style0 from "./CustomSubjectLine.vue?vue&type=style&index=0&id=5d6c700a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6c700a",
  null
  
)

export default component.exports